import React, { Component } from "react";
import { Button } from "reactstrap";
import style from "./CreateProcedures.module.css";
import history from "../../utils/history";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import api from "../../utils/Api";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import { trimEnd } from "lodash";

export class CreateProcedures extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialValues: {
        procedure_name: "",
        procedure_time: "",
        procedure_cost: "",
      },
      isLoading: false,
      isEditLoading: false,
      successMessage: "",
      errorMessage: "",
      pageTitle: "Add Medical Procedure",
      isEditMode: false,
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.setState({
        isEditMode: true,
        isEditLoading: true,
        pageTitle: "Update Medical Procedure",
      });
      this.procedureDetails();
    }
  }

  procedureDetails = async () => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.get(
        "procedure/" + this.props.match.params.id,
        {
          headers: headers,
        }
      );
      let procDetails = response.data.data;

      this.setState({
        initialValues: {
          procedure_name: procDetails.procedure_name,
          procedure_time: procDetails.procedure_time,
          procedure_cost: procDetails.procedure_cost,
        },
        isEditLoading: false,
      });
    } catch (error) {
      console.log("Redux error - ", error);
      this.setState({
        isEditLoading: false,
      });
    }
  };

  // Handle back button
  backHandleClick() {
    history.push("/procedureslist");
  }

  render() {
    return (
      <div className={style.proceduresMainWrapper}>
        <div className="row">
          <div className="col-md-12">
            <h3>{this.state.pageTitle}</h3>
          </div>
        </div>
        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            procedure_name: Yup.string().trim()
            .required("Procedure name is required")
            .matches(/^[a-zA-Z0-9 ]*$/, "Only aplphanumeric values allowed"),
            procedure_time: Yup.string().required("Time is required"),
            procedure_cost: Yup.string()
              .required("Procedure cost is required")
              .matches(/^\d+$/, "Only numbers allowed"),
          })}
          onSubmit={async (data) => {
            this.setState({
              isLoading: true,
            });

            // Headers
            const headers = {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
            };

            const payload = {
              procedure_name: data.procedure_name,
              procedure_time: data.procedure_time,
              procedure_cost: Number(data.procedure_cost),
            };

            if (this.state.isEditMode) {
              payload.procedure_id = this.props.match.params.id;
            }

            try {
              const response = await api.post("procedure", payload, {
                headers: headers,
              });
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                  successMessage: "Medical procedure created successfully!",
                });
                if (this.state.isEditMode) {
                  this.setState({
                    isLoading: false,
                    successMessage: "Medical procedure updated successfully!",
                  });
                }
              }
              setTimeout(() => {
                this.setState({
                  successMessage: "",
                });
                history.push("/procedureslist");
              }, 2000);
            } catch (error) {
              if (error.response) {
                this.setState({
                  isLoading: false,
                  errorMessage: "Internal server error occured",
                });
                setTimeout(() => {
                  this.setState({
                    errorMessage: "",
                  });
                }, 2000);
              }
            }
          }}
          render={({ errors, status, touched }) => (
            <Form>
              {this.state.isEditLoading ? (
                <div className={style.loadingWrapper}>
                  <img src={ttmLoader} className={style.loading} />
                </div>
              ) : (
                <div>
                  <div className={style.createProcWrapper}>
                    <div className="row">
                      <div className="col-md-12">
                        {/* <h4>Room Details</h4> */}
                      </div>
                    </div>
                    <div class="form-box-shadow">
                      <div className="row">
                        <div className="col-md-6 col-lg-6 col-xl-3">
                          <div className="form-group">
                            <label htmlFor="procedure_name">
                              Procedure Name
                              <span className="mandatory">
                                <small>*</small>
                              </span>
                            </label>
                            <Field
                              name="procedure_name"
                              type="text"
                              maxLength="20"
                              className={
                                "form-control" +
                                (errors.procedure_name && touched.procedure_name
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="procedure_name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                          <div className="form-group">
                            <label htmlFor="procedure_time">
                              Time Required
                              <span className="mandatory">
                                <small>*</small>
                              </span>
                            </label>
                            <Field
                              as="select"
                              name="procedure_time"
                              className={
                                "form-control" +
                                (errors.procedure_time && touched.procedure_time
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value="">Select location</option>
                              <option>30 mins</option>
                              <option>1 hour</option>
                              <option>2 hours</option>
                              <option>3 hours</option>
                            </Field>
                            <ErrorMessage
                              name="procedure_time"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                          <div className="form-group">
                            <label htmlFor="procedure_cost">
                              Procedure Cost (ZAR)
                              <span className="mandatory">
                                <small>*</small>
                              </span>
                            </label>
                            <Field
                              name="procedure_cost"
                              type="text"
                              maxLength="7"
                              className={
                                "form-control" +
                                (errors.procedure_cost && touched.procedure_cost
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="procedure_cost"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3"></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className={style.roomBtnWrapper}>
                        <Button
                          type="button"
                          className="form-primary-btn"
                          onClick={this.backHandleClick}
                        >
                          Cancel
                        </Button>
                        <Button type="submit" className="form-primary-btn">
                          Save
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="row">
                <div className="col-md-12">
                  {this.state.isLoading ? (
                    <div className={style.loadingWrapper}>
                      <img src={ttmLoader} className={style.loading} />
                    </div>
                  ) : (
                    <div>
                      {this.state.successMessage && (
                        <p className={style.successMessage}>
                          {this.state.successMessage}
                        </p>
                      )}
                      {this.state.errorMessage && (
                        <p className={style.errorMessage}>
                          {this.state.errorMessage}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Form>
          )}
        />
      </div>
    );
  }
}

export default CreateProcedures;
